import React from 'react';
import { Button, CUIText, Icon, IconNames } from '@dotcom/crown-ui';
import classNames from 'classnames';
import { ButtonGroup } from '../../../button-group/button-group';
import { AlignmentProps } from '../font-drawer-types';
import styles from '../font-drawer.module.scss';

const buttonList = [
  { icon: IconNames.AlignLeftBold, ariaLabel: 'Left Justify' },
  { icon: IconNames.AlignCenterBold, ariaLabel: 'Center Justify' },
  { icon: IconNames.AlignRightBold, ariaLabel: 'Right Justify' },
];

export const Alignment = ({
  addClass = '',
  label,
  buttonGroupClick,
  activeIndex,
}: AlignmentProps): React.ReactElement => {
  const wrapperClasses = classNames(styles.alignment);

  const handleIndexChange = (index: number) => {
    buttonGroupClick(index);
  };

  return (
    <div className={wrapperClasses}>
      <CUIText variant="form" as="label">
        Align
      </CUIText>

      <ButtonGroup
        ariaLabel={label}
        activeClassOverride={styles.active}
        selectedIndex={activeIndex}
        onIndexChange={handleIndexChange}
        addClass={styles.containerButtons}
      >
        {buttonList.map(({ icon, ariaLabel }, index) => {
          const isActive = activeIndex === index;
          const buttonClass = classNames(styles.buttons, isActive && styles.active);
          return (
            <Button
              aria-label={ariaLabel}
              onClick={() => null}
              className={buttonClass}
              role="option"
              key={index}
              data-active={isActive}
              variant={isActive ? 'primary' : 'secondary'}
              size="icon"
            >
              <Icon name={icon} className={isActive ? styles.iconActive : styles.icons} />
            </Button>
          );
        })}
      </ButtonGroup>
    </div>
  );
};
